var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var CommonUtils = require('../../utils/common-utils.js');

var utils = new CommonUtils();

var ExacerbationsRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/medicals/exacerbations-row.html'),

    ui: {
        edit: '.edit',
        remove: '.remove'
    },

    events: {
        'click @ui.edit': 'onEdit',
        'click @ui.remove': 'onRemove'
    },

    templateContext: function () {
        var that = this;
        var startDate = that.model.get('startDate');
        var stopDate = that.model.get('stopDate');
        return {
            startDate: startDate != undefined && startDate != '' && !isNaN(startDate) ? utils.longToDateTimeFormatted(startDate, 'MM/DD/YYYY') : '',
            stopDate: stopDate != undefined && stopDate != '' && !isNaN(stopDate) ? utils.longToDateTimeFormatted(stopDate, 'MM/DD/YYYY') : '',
            isReadOnly: that.isReadOnly
        }
    },

    initialize: function (options) {
        var that = this;
        this.isReadOnly = this.getOption('isReadOnly');
    },

    onRender: function () {

    },

    onEdit: function () {
        this.triggerMethod('edit:exacerbation', {model: this.model});
    },

    onRemove: function () {
        this.triggerMethod('remove:exacerbation', {model: this.model});
    }
});


var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(3), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var ExacerbationsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: ExacerbationsRowView,
    emptyView: EmptyView,

    collectionEvents: {},

    childViewEvents: {
        'remove:exacerbation': 'removeExacerbation',
        'edit:exacerbation': 'editExacerbation'
    },

    childViewOptions: function () {
        return {
            isReadOnly: this.isReadOnly
        };
    },

    initialize: function (options) {
        this.collection = options.collection;
        this.isReadOnly = options.isReadOnly;
    },

    removeExacerbation: function (data) {
        this.triggerMethod('remove:exacerbation', data);
    },

    editExacerbation: function (data) {
        this.triggerMethod('edit:exacerbation', data);
    }
});

var ExacerbationsView = Marionette.View.extend({
    template: require('../../templates/medicals/exacerbations.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        }
    },

    ui: {
        editInputs: '#edits',
        startDate: '#e-start-date',
        stopDate: '#e-stop-date',
        comment: '#e-comment',
        newBtn: '#e-new',
        saveBtn: '#e-save'
    },

    events: {
        'click @ui.newBtn': 'newExac',
        'click @ui.saveBtn': 'saveExac'
    },

    childViewEvents: {
        'remove:exacerbation': 'removeExacerbation',
        'edit:exacerbation': 'editExacerbation'
    },

    tempModel: undefined,

    templateContext: function () {
        var that = this;
        return {
            isReadOnly: that.isReadOnly
        }
    },


    initialize: function (options) {
        _.bindAll(this, 'onRender', 'newExac', 'saveExac', 'clearEditables', 'removeExacerbation', 'editExacerbation',
            'getAllExacerbations', 'resetCollection');
        if (options) {
            this.exacerbations = options.exacerbations;
            this.isReadOnly = options.isReadOnly;
        }
    },

    onRender: function () {
        var that = this;

        that.ui.startDate.datepicker({
            format: 'mm/dd/yyyy',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });
        that.ui.stopDate.datepicker({
            format: 'mm/dd/yyyy',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });

        that.ui.saveBtn.hide();
        that.ui.editInputs.hide();

        that.exacerbationsCollection = new Backbone.Collection(that.exacerbations);
        that.showChildView('body', new ExacerbationsTableBody({
            collection: that.exacerbationsCollection,
            isReadOnly: that.isReadOnly
        }));
    },

    newExac: function () {
        this.ui.newBtn.hide();
        this.ui.saveBtn.show();
        this.ui.editInputs.show();
        this.tempModel = new Backbone.Model({
            id: utils.randomString(18)
        });
    },

    saveExac: function () {
        this.tempModel.set('startDate', utils.dateToLong(this.ui.startDate.val()));
        this.tempModel.set('stopDate', utils.dateToLong(this.ui.stopDate.val()));
        this.tempModel.set('comment', this.ui.comment.val());
        var newModel = _.clone(this.tempModel);
        this.exacerbationsCollection.remove(this.tempModel);
        this.exacerbationsCollection.add(this.tempModel);

        this.clearEditables();
        this.ui.editInputs.hide();
        this.ui.newBtn.show();
        this.ui.saveBtn.hide();
    },

    clearEditables: function () {
        this.ui.startDate.val('');
        this.ui.stopDate.val('');
        this.ui.comment.val('');
    },

    removeExacerbation: function (data) {
        this.exacerbationsCollection.remove(data.model);
    },

    editExacerbation: function (data) {
        this.ui.newBtn.hide();
        this.ui.saveBtn.show();
        this.ui.editInputs.show();
        this.tempModel = data.model;

        var startDate = data.model.get('startDate');
        var stopDate = data.model.get('stopDate');
        this.ui.startDate.val(startDate != undefined && startDate != '' && !isNaN(startDate) ? utils.longToDateTimeFormatted(startDate, 'MM/DD/YYYY') : '');
        this.ui.stopDate.val(stopDate != undefined && stopDate != '' && !isNaN(stopDate) ? utils.longToDateTimeFormatted(stopDate, 'MM/DD/YYYY') : '');
        this.ui.comment.val(data.model.get('comment'));
    },

    getAllExacerbations: function () {
        var exacerbations = this.exacerbationsCollection.toJSON().map(function (exacerbation) {
            return _.omit(exacerbation, 'id');
        });
        return exacerbations;
    },

    resetCollection: function (exacerbations) {
        this.exacerbationsCollection.reset(exacerbations);
    }

});

module.exports = ExacerbationsView;


//////////////////
// WEBPACK FOOTER
// ./app/views/medicals/exacerbations-view.js
// module id = 358
// module chunks = 0